






































































































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { activityFields } from '@/config/activities';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import { Activity } from '@activities/interfaces/activity';
import FormProvider from '@shared/components/forms/form-provider.vue';
import Input from '@shared/components/forms/inputs/input/input.vue';
import MultiSelect from '@shared/components/forms/inputs/multi-select/multi-select.vue';
import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import Datepicker from '@shared/components/forms/inputs/datepicker/datepicker.vue';
import DayTimeRepeater from '@shared/components/forms/inputs/day-time-repeater/day-time-repeater.vue';
import { setProp } from '@shared/helpers/operators';

@Component({
  name: 'bpc-membership-category-form',
  components: {
    'bpc-form-provider': FormProvider,
    'bpc-input': Input,
    'bpc-multi-select': MultiSelect,
    'bpc-entity-select': EntitySelect,
    'bpc-datepicker': Datepicker,
    'bpc-day-time-repeater': DayTimeRepeater,
  },
})
export default class CreateBasicActivityForm extends Vue {
  $refs!: {
    formProvider: InstanceType<typeof FormProvider> & {
      errorsObject: object;
      saveEntity(formModel: AnyEntity): Promise<BPCGenericApiResponse>;
      resetErrorObject(): void;
    };
  };
  // PROPS
  @Prop(Object) readonly initialData: Activity;
  @Prop(Number) readonly modelId: number;
  @Prop({ type: Boolean, default: false }) readonly show: boolean;
  @Prop({ type: Boolean, default: true }) readonly noFetchData: boolean;
  @Prop({ type: Boolean, default: false }) readonly showCancelButton: boolean;
  @Prop({ type: String, default: null }) readonly blockedType;
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  readonly value: Activity;
  @Prop({
    type: String,
  })
  readonly cancelButtonsPortalTarget: string;

  @Prop({
    type: String,
  })
  readonly saveButtonsPortalTarget: string;

  // DATA
  // COMPUTED
  get labelName() {
    return this.blockedType
      ? `activities.activity.${this.blockedType}.name.label`
      : 'activities.activity.name.label';
  }

  get formModel(): Activity {
    return this.value;
  }
  set formModel(value) {
    this.$emit('input', value);
  }

  get fieldsConfig() {
    return activityFields;
  }

  get selectedTypeDescription() {
    return this.$t(
      this.fieldsConfig.activity_type.options.find(
        item => item.value === this.formModel.activity_type,
      )?.description,
    );
  }

  get activityType() {
    return this.formModel?.activity_type;
  }

  get savePath() {
    if (this.blockedType) {
      return this.$bpcApiRouteHelper
        .getEntityPath('bpc-activity')
        .concat(`/${this.blockedType}/create`);
    } else {
      return this.$bpcApiRouteHelper.getEntityPath('bpc-activity').concat('/v2/create');
    }
  }

  // LIFECYCLE
  // created(){}
  mounted() {
    if (this.blockedType) {
      setProp(this.formModel, 'activity_type', this.blockedType);
    }
  }
  // updated(){}
  // destroyed(){}

  // METHODS
  onEntitySaved(e) {
    this.$emit('entity-saved', e);
    this.onClose();
  }

  onEntityErrorSaving(e) {
    this.$bpcMessage.showErrorMessage({
      text: 'core.superadmin_form_update_errors',
    });
    this.$emit('entity-error-saving', e);
  }

  onValidationWarning(e) {
    this.$emit('validation-warning', e);
  }

  onSavingEntity(event) {
    this.$emit('saving-entity', event);
  }

  onModelLoaded(event) {
    this.$emit('model-loaded', event);
  }

  onConfigLoaded(event) {
    this.$emit('config-loaded', event);
  }

  onClose() {
    this.$emit('close');
  }

  onChangePeriod(period) {
    this.formModel.period_id = period?.id || null;
    if (period && period.start_date) {
      this.formModel.start_date = period.start_date;
    }
    if (period && period.end_date) {
      this.formModel.end_date = period.end_date;
    }
  }

  onChangeContact(contact) {
    this.formModel.contact_id = contact?.id || null;
  }

  onChangeTeam(team) {
    this.formModel.team_id = team?.id || null;
  }

  // WATCHERS
}
